export default "__VITE_ASSET__DQyx$92K__"